/* eslint-disable camelcase,react/jsx-curly-newline */
import React, { useEffect, useRef, useState } from 'react';
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Switch,
  DatePicker,
  message,
  Select,
  PageHeader,
  Descriptions,
  Tag,
  Tabs,
} from 'antd';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { ExportOutlined } from '@ant-design/icons';
import SIGLO_TRANSACTION_TYPES from '../../domain/sigloTransactionTypes';
import { SIGLO_UI_PRODUCTS, TX_ALL_METHODS, parseSigloProductName } from '../../domain/sigloFixedProductCatalog';
import { main, secondary, background } from '../../Utils/Colors';
import { getRequests, getSigloPartnerConfigStatus, updateRequest } from '../Aplication/Requests.business';
import RequestModel from '../Domain/Request.model';
import { deselectRecord } from '../Infrastructure/Requests.store';
import { getRequestSelector, getSelectedRequest } from '../Infrastructure/Requests.reducer';
import { getUsersSelector } from '../../Users/Infrastructure/Users.reducer';
import { getUsers } from '../../Users/Application/Users.business';
import styles2 from './Styles.css';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import Moratorium from './Moratorium';
import CustomInputNumber from '../../Utils/common/CustomInputNumber/UI/CustomInputNumber';
import CustomInputTypeNumber from '../../Utils/common/CustomInputTypeNumber/UI/CustomInputTypeNumber';

const { Option } = Select;

const { TabPane } = Tabs;

const styles = {
  background: {
    margin: '0.7em 0em',
    borderRadius: '15px',
    padding: '1em',
    boxShadow: '3px 5px 5px 1px rgb(213,196,233, 0.5)',
    transition: 'all 0.2s',
  },
  button: {
    size: 'large',
  },
};

export default function RequestsForm() {
  // eslint-disable-next-line react/no-this-in-sfc

  const selected = useSelector(getSelectedRequest);
  const recordsUser = useSelector(getUsersSelector);
  const records = useSelector(getRequestSelector);

  // const valueUser = useSelector(getUser(selected.user));

  const [isLeasing, setIsLeasing] = useState(selected?.leasing || false);
  const [isloading, setIsLoading] = useState(false);
  const [lenderId, setLenderId] = useState(selected?.user_lender || null);
  const [isSigloConfigComplete, setIsSigloConfigComplete] = useState(false);
  const [isSigloConfigLoading, setIsSigloConfigLoading] = useState(false);
  const configRequestSequence = useRef(0);
  const [form] = Form.useForm();

  // Efecto para actualizar cuando cambia selected
  useEffect(() => {
    setIsLeasing(selected?.leasing || false);
  }, [selected]);

  useEffect(() => {
    if (!selected) return;
    const parsedProduct = selected.user_lender ? parseSigloProductName(selected.siglo_product_name) : null;
    form.setFieldsValue({
      ...newSelected,
      payment_type:
        selected?.payment_type !== undefined && selected?.payment_type !== null
          ? selected.payment_type.toString()
          : undefined,
      recognition: selected?.recognition?.toString(),
      status: selected?.status?.toString(),
      siglo_pld_product: parsedProduct ? `${parsedProduct.label} (${parsedProduct.code})` : undefined,
      siglo_pld_method: parsedProduct?.method,
    });
    setLenderId(selected.user_lender || null);
  }, [form, selected]);

  useEffect(() => {
    const sequence = configRequestSequence.current + 1;
    configRequestSequence.current = sequence;
    setIsSigloConfigComplete(false);

    if (!lenderId) {
      setIsSigloConfigLoading(false);
      return undefined;
    }

    setIsSigloConfigLoading(true);
    getSigloPartnerConfigStatus(lenderId)
      .then((status) => {
        if (configRequestSequence.current !== sequence) return;
        const isComplete = status?.isComplete === true;
        setIsSigloConfigComplete(isComplete);
        if (!isComplete) {
          form.setFieldsValue({
            siglo_pld_product: undefined,
            siglo_pld_method: undefined,
            siglo_transaction_type_code: undefined,
          });
        }
      })
      .catch(() => {
        if (configRequestSequence.current !== sequence) return;
        setIsSigloConfigComplete(false);
        form.setFieldsValue({
          siglo_pld_product: undefined,
          siglo_pld_method: undefined,
          siglo_transaction_type_code: undefined,
        });
      })
      .finally(() => {
        if (configRequestSequence.current === sequence) setIsSigloConfigLoading(false);
      });

    return () => {
      if (configRequestSequence.current === sequence) configRequestSequence.current += 1;
    };
  }, [form, lenderId]);

  const newValueUser = selected?.user_data?.username;
  const newValueUserLender = selected?.user_lender_data?.username;
  const newValueRequestParent = selected?.request_parent_data?.token;
  const newValueUserAval = selected?.user_aval_data?.username;
  const newBilling_end_of_month = selected?.billing_end_of_month;

  const newSelected = {
    ...selected,
    user: newValueUser,
    user_lender: newValueUserLender,
    request_parent: newValueRequestParent,
    user_aval: newValueUserAval,
    billing_end_of_month: newBilling_end_of_month,
  };

  const history = useHistory();

  const onFinish = async (values) => {
    if (lenderId && isSigloConfigLoading) {
      message.info('Espera mientras se valida la configuración SIGLO del prestador.');
      return;
    }
    const product = String(values.siglo_pld_product || '').trim();
    const method = String(values.siglo_pld_method || '').trim();
    const requestValues = {
      ...values,
      siglo_product_name: isSigloConfigComplete && product && method ? `${product} - ${method}` : null,
    };
    delete requestValues.siglo_pld_product;
    delete requestValues.siglo_pld_method;

    setIsLoading(true);
    updateRequest(selected, requestValues, isSigloConfigComplete)
      .then(() => {
        const urlId = selected.id;
        message.success('Solicitud modificada con éxito');
        deselectRecord();
        history.push(`/requests/${urlId}`);
        window.location.reload();
      })
      .catch((e) => {
        const messageError = e?.message || e?.request?.response || String(e);
        message.error(`Error al modificar solicitud: ${messageError}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancel = () => {
    deselectRecord();
  };

  function onSearchUser(val) {
    getUsers({ q: val, type: 'user' });
  }

  function onSearchUserLender(val) {
    getUsers({ q: val, type: 'user_lender' });
  }

  function onSearchUserAval(val) {
    getUsers({ q: val, type: 'user_aval' });
  }

  function onSearchToken(val) {
    getRequests({ q: val });
  }

  function onChangeUserLender(value) {
    setLenderId(value || null);
    setIsSigloConfigComplete(false);
    setIsSigloConfigLoading(Boolean(value));
    form.setFieldsValue({
      siglo_pld_product: undefined,
      siglo_pld_method: undefined,
      siglo_transaction_type_code: undefined,
    });
  }

  return selected ? (
    <div style={styles.background} className={styles2}>
      <PageHeader
        className="site-page-header"
        onBack={deselectRecord}
        title="Solicitud:"
        extra={[
          <Link
            key="external"
            to={{ pathname: `${process.env.REACT_APP_HOST}/#/requests/${selected.id}` }}
            target="_blank"
          >
            <span>Abrir en Dashboard</span>
            <ExportOutlined style={{ marginLeft: '1em' }} />
          </Link>,
        ]}
      >
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Token">
            <Tag color={secondary}>{selected.token}</Tag>
          </Descriptions.Item>
          {/* <Descriptions.Item>
            <Button type="primary" shape="round" style={styles.button} onClick={() => handleClick(selected.id)}>
              Calcular
            </Button>
          </Descriptions.Item> */}
        </Descriptions>
      </PageHeader>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Información" key="1">
          <Form form={form} onFinish={onFinish} initialValues={selected}>
            <Row gutter={[48, 16]}>
              <Col span={8}>
                <PageHeader title="Información General" />
                <Row gutter={[24, 16]}>
                  <Col span={16}>
                    <Form.Item
                      hasFeedback
                      name="status"
                      label="Status"
                      rules={[{ required: true, message: 'Status no puede estar vacio' }]}
                    >
                      <Select showSearch>
                        <Option value="1">Activa</Option>
                        <Option value="3">Cancelada</Option>
                        <Option value="4">Finalizada</Option>
                        <Option value="6">En Espera de Fondos</Option>
                        <Option value="8">En Espera de Autorización</Option>
                        <Option value="10">En Espera de Firmas</Option>
                        <Option value="9">Por Renovar</Option>
                        <Option value="11">Validación de Documentos</Option>
                        <Option value="12">Creación de Documentos</Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="request_parent" label="Token padre">
                      <Select
                        showSearch
                        placeholder="Selecciona un token"
                        optionFilterProp="children"
                        /* eslint-disable-next-line react/jsx-no-bind */
                        onSearch={onSearchToken}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {records?.map((record) => (
                          <Option value={record.id} key={record.id}>
                            {record.token}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {/*   <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="user"
                      label="Solicitante"
                      rules={[
                        {
                          required: true,
                          message: 'Solicitante no puede estar vacio',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
*/}

                  <Col span={24}>
                    <Form.Item
                      name="user"
                      label="Solicitante"
                      rules={[{ required: true, message: 'No puede ir vacio' }]}
                    >
                      <Select
                        placeholder="Selecciona un usuario"
                        showSearch
                        optionFilterProp="children"
                        /* eslint-disable-next-line react/jsx-no-bind */
                        onSearch={onSearchUser}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {recordsUser?.map((recordUser) => (
                          <Option value={recordUser.id} key={recordUser.id}>
                            {recordUser.username || recordUser.email}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {/*          <Col span={24}>
                    <Form.Item hasFeedback name="user_lender" label="Prestador">
                      <Input />
                    </Form.Item>
                  </Col>
*/}
                  <Col span={24}>
                    <Form.Item name="user_lender" label="Prestador">
                      <Select
                        placeholder="Selecciona un usuario"
                        showSearch
                        optionFilterProp="children"
                        /* eslint-disable-next-line react/jsx-no-bind */
                        onSearch={onSearchUserLender}
                        /* eslint-disable-next-line react/jsx-no-bind */
                        onChange={onChangeUserLender}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {recordsUser?.map((recordUser) => (
                          <Option value={recordUser.id} key={recordUser.id}>
                            {recordUser.username || recordUser.email}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item name="user_aval" label="Aval">
                      <Select
                        placeholder="Selecciona un usuario"
                        showSearch
                        optionFilterProp="children"
                        /* eslint-disable-next-line react/jsx-no-bind */
                        onSearch={onSearchUserAval}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {recordsUser?.map((recordUser) => (
                          <Option value={recordUser.id} key={recordUser.id}>
                            {recordUser.username || recordUser.email}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="recognition"
                      label="Producto"
                      rules={[
                        {
                          required: true,
                          message: 'Tipo de solicitud no puede estar vacio',
                        },
                      ]}
                    >
                      <Select showSearch>
                        {Object.keys(RequestModel.constants.typeRequest).map((key) => (
                          <Option key={key} value={key}>
                            {RequestModel.constants.typeRequest[key]}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="title"
                      label="Título"
                      rules={[{ required: true, message: 'Título no puede estar vacio' }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="description"
                      label="Descripción"
                      rules={[
                        {
                          required: true,
                          message: 'Descripción no puede estar vacio',
                        },
                      ]}
                    >
                      <Input.TextArea style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="comment" label="Comentarios">
                      <Input.TextArea style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <PageHeader title="Resumen del préstamo" />
                <Row gutter={12}>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="amount"
                      label="Capital"
                      rules={
                        isLeasing
                          ? []
                          : [
                              { required: true, message: 'Monto no puede estar vacio' },
                              {
                                message: 'Solo se permiten dos digitos',
                                pattern: /^\d+(\.\d{1,2})?$/,
                              },
                            ]
                      }
                    >
                      <CustomInputNumber
                        formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="rate"
                      label="Tasa"
                      rules={
                        isLeasing
                          ? []
                          : [
                              { required: true, message: 'Tasa no puede estar vacio' },
                              {
                                message: 'Solo se permiten números',
                                pattern: /^\d+(\.\d+)?$/,
                              },
                            ]
                      }
                    >
                      <CustomInputTypeNumber suffix="%" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="late_fee_factor"
                      label="Tasa de interés moratorio"
                      rules={[
                        { required: true, message: 'Tasa no puede estar vacio' },
                        {
                          message: 'La tasa debe ser mayor o igual a 1%',
                          pattern: /^(?!0+(?:\.0+)?$)([1-9]\d*(?:\.\d+)?|0?\.\d*[1-9]|0\.[1-9]\d*)$/,
                        },
                      ]}
                    >
                      <CustomInputTypeNumber step={0.01} />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item hasFeedback name="iva" label="IVA">
                      <Select suffix="%" style={{ width: 100 }} showSearch>
                        <Option value="0">0</Option>
                        <Option value="16">16</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="isr_withholdings" label="Tasa de retención de ISR">
                      <CustomInputNumber
                        formatter={(value) => `${value}%`}
                        parser={(value) => value.replace('%', '')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="iva_withholdings" label="Tasa de retención de IVA">
                      <CustomInputNumber
                        formatter={(value) => `${value}%`}
                        parser={(value) => value.replace('%', '')}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      hasFeedback
                      name="payment_time"
                      label="Periodicidad"
                      rules={
                        isLeasing
                          ? []
                          : [
                              { required: true, message: 'Tiempo no puede estar vacio' },
                              {
                                message: 'Solo se permiten números',
                                pattern: /^\d*$/,
                              },
                              () => ({
                                validator(rule, value) {
                                  const numValue = Number(value);
                                  if (!numValue || numValue >= 1) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(new Error('Solo puedes usar valores mayor o igual a 1'));
                                },
                              }),
                            ]
                      }
                    >
                      <CustomInputTypeNumber />
                    </Form.Item>
                  </Col>

                  {!selected?.leasing && (
                    <Col span={24}>
                      <Form.Item
                        hasFeedback
                        name="payment_type"
                        label="Plazo"
                        rules={
                          isLeasing
                            ? []
                            : [
                                {
                                  required: true,
                                  message: 'Plazo no puede estar vacio',
                                },
                              ]
                        }
                      >
                        <Select showSearch style={{ width: 150 }}>
                          {Object.keys(RequestModel.constants.ptypes).map((key) => (
                            <Option key={key} value={key}>
                              {RequestModel.constants.ptypes[key]}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}

                  <Col span={20}>
                    <Form.Item
                      hasFeedback
                      name="number_of_capital_grace_periods"
                      // prettier-ignore
                      label={(
                        <span
                          style={{
                            whiteSpace: 'normal',
                            textAlign: "start",
                            wordWrap: 'break-word',
                            lineHeight: '1',
                            display: 'inline-block',
                            width: '140px',
                          }}
                        >
                          Periodos de gracia de capital
                        </span>
                      )}
                      style={{ display: 'flex', alignItems: 'flex-start', height: 'auto', width: '100%' }}
                      rules={[
                        { required: true, message: 'Periodos de gracia no puede estar vacio' },
                        {
                          message: 'Solo se permiten números',
                          pattern: /^\d*$/,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const numValue = Number(value);
                            const paymentTime = Number(getFieldValue('payment_time'));

                            if (Number.isNaN(numValue)) {
                              return Promise.reject(new Error('Debe ser un número válido'));
                            }
                            if (numValue < 0) {
                              return Promise.reject(new Error('El valor mínimo es 0'));
                            }
                            if (!Number.isNaN(paymentTime) && numValue > paymentTime) {
                              return Promise.reject(new Error(`No puede ser mayor a la periodicidad (${paymentTime})`));
                            }

                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <CustomInputTypeNumber />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="date"
                      label="Fecha"
                      rules={[{ required: true, message: 'Fecha no puede estar vacio' }]}
                    >
                      <DatePicker style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="activation_date" label="Fecha de Activación">
                      <DatePicker style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>
                  <Form.Item
                    shouldUpdate={(prevValues, currentValues) => prevValues.version !== currentValues.version}
                    noStyle
                  >
                    {() =>
                      form.getFieldValue('version') !== 'v1' && (
                        <>
                          <Col span={24}>
                            <Form.Item
                              hasFeedback
                              name="billing_end_of_month"
                              label="Ajustar pagos al último días de cada mes"
                              initialValue={selected?.billing_end_of_month}
                              valuePropName="checked"
                            >
                              <Switch defaultChecked={selected?.billing_end_of_month} />
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item hasFeedback name="preferred_payment_day" label="Fecha de primer pago">
                              <DatePicker style={{ borderRadius: 20 }} />
                            </Form.Item>
                          </Col>
                        </>
                      )
                    }
                  </Form.Item>
                  <Col span={24}>
                    <Form.Item hasFeedback name="finish_date" label="Fecha de Finalización">
                      <DatePicker style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="waiting_funds_date"
                      label="Fecha de Espera de fondos"
                      rules={[{ required: false }]}
                    >
                      <DatePicker style={{ borderRadius: 20 }} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item hasFeedback name="dispersed" label="Dispersado" initialValue={selected?.dispersed}>
                      <Switch defaultChecked={selected?.dispersed} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      hasFeedback
                      name="aval_required"
                      label="Aval requerido"
                      initialValue={selected.aval_required}
                    >
                      <Switch defaultChecked={selected.aval_required} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item hasFeedback name="guarantee" label="Garantía" initialValue={selected?.guarantee}>
                      <Switch defaultChecked={selected.guarantee} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    {isSigloConfigComplete ? (
                      <>
                        <PageHeader title="Reporte PLD / SIGLO" style={{ padding: 0 }} />
                        <Form.Item
                          hasFeedback
                          name="siglo_pld_product"
                          label="Producto PLD"
                          rules={[{ required: true, message: 'Seleccione un producto PLD/FT' }]}
                        >
                          <Select showSearch placeholder="Producto PLD/FT" optionFilterProp="children">
                            {SIGLO_UI_PRODUCTS.map(({ label, code, displayLabel }) => {
                              const value = `${label} (${code})`;
                              return (
                                <Option key={value} value={value}>
                                  {displayLabel || value}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          hasFeedback
                          name="siglo_pld_method"
                          label="Método de pago PLD"
                          rules={[{ required: true, message: 'Seleccione un método de pago' }]}
                        >
                          <Select showSearch placeholder="Método de pago" optionFilterProp="children">
                            {TX_ALL_METHODS.map((method) => (
                              <Option key={method} value={method}>
                                {method}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          hasFeedback
                          name="siglo_transaction_type_code"
                          label="Tipo de transacción PLD"
                          rules={[{ required: true, message: 'Seleccione el tipo de transacción' }]}
                        >
                          <Select showSearch placeholder="Tipo de transacción" optionFilterProp="children">
                            {SIGLO_TRANSACTION_TYPES.map((tx) => (
                              <Option key={tx.id} value={tx.id}>
                                {`${tx.id} — ${tx.label}`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </>
                    ) : null}
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <PageHeader title="Comisiones" />
                <Row gutter={12}>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Comisión no puede estar vacia',
                        },
                      ]}
                      name="commission_admin"
                      label="Comisión por admin solicitante"
                    >
                      <CustomInputNumber
                        min={0}
                        max={10}
                        step={0.5}
                        formatter={(value) => `${parseFloat(value).toFixed(5)}`} // Formatea el valor como número decimal con un decimal
                        parser={(value) => parseFloat(value)} // Analiza el valor como un número decimal
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Comisión no puede estar vacia',
                        },
                      ]}
                      name="commission_admin_lender"
                      label="Comisión por admin prestador"
                    >
                      <CustomInputNumber
                        min={0}
                        max={10}
                        step={0.5}
                        formatter={(value) => `${parseFloat(value).toFixed(5)}`} // Formatea el valor como número decimal con un decimal
                        parser={(value) => parseFloat(value)} // Analiza el valor como un número decimal
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Comisión no puede estar vacia',
                        },
                      ]}
                      name="opening_commission"
                      label="Tasa de comisión por apertura"
                    >
                      <CustomInputNumber
                        min={0}
                        max={10}
                        step={0.5}
                        formatter={(value) => `${parseFloat(value).toFixed(5)}`} // Formatea el valor como número decimal con un decimal
                        parser={(value) => parseFloat(value)} // Analiza el valor como un número decimal
                      />

                      {/* <Input suffix="%" type="number" step="0.01" pattern="^\d*(\.\d{0,2})?$" /> */}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Comisión no puede estar vacia',
                        },
                      ]}
                      name="commission_by_each_payment"
                      label="Comisión por cada pago"
                    >
                      <CustomInputTypeNumber prefix="$" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Comisión no puede estar vacia',
                        },
                      ]}
                      name="opening_commission_amount"
                      label="Monto  de comisión por apertura"
                    >
                      <CustomInputNumber
                        formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                      />

                      {/* <Input suffix="%" type="number" step="0.01" pattern="^\d*(\.\d{0,2})?$" /> */}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <PageHeader title="Información de Desarrollo" />
                <Row gutter={[24, 16]}>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="version"
                      label="Versión de calculos"
                      rules={[{ required: true, message: 'Plazo no puede estar vacío' }]}
                    >
                      <Select showSearch style={{ width: 100 }}>
                        {Object.keys(RequestModel.constants.ptypesVersion).map((key) => (
                          <Option key={key} value={key}>
                            {RequestModel.constants.ptypesVersion[key]}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      hasFeedback
                      name="version_commission"
                      label="Versión de comisión"
                      rules={[{ required: true, message: 'Plazo no puede estar vacío' }]}
                    >
                      <Select showSearch style={{ width: 100 }}>
                        {Object.keys(RequestModel.constants.ptypesVersion).map((key) => (
                          <Option key={key} value={key}>
                            {RequestModel.constants.ptypesVersion[key]}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="hash" label="Hash">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="key" label="Key">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item hasFeedback name="merged_contract" label="Unión de Contratos">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item hasFeedback name="hidden_applicant" label="Ocultar Solicitante">
                      <Switch defaultChecked={selected.hidden_applicant} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item hasFeedback name="hidden_lender" label="Ocultar Prestador">
                      <Switch defaultChecked={selected.hidden_lender} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item hasFeedback name="hidden_aval" label="Ocultar Aval">
                      <Switch defaultChecked={selected.hidden_aval} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item hasFeedback name="stamped" label="Estampado">
                      <Switch defaultChecked={selected.stamped} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col>
                <Button onClick={cancel} danger>
                  Cancelar
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  style={{
                    background: main,
                    color: background,
                  }}
                  htmlType="submit"
                  loading={isloading}
                  disabled={isloading || isSigloConfigLoading}
                >
                  {isloading ? 'Guardando...' : 'Guardar'}
                </Button>
              </Col>
            </Row>
          </Form>
        </TabPane>
        <TabPane tab="Moratorios" key="2">
          <Moratorium selected={selected} />
        </TabPane>
        <TabPane tab="Contratos" key="3">
          Contratos
        </TabPane>

        <TabPane tab="Pagos" key="4">
          En construcción
        </TabPane>
      </Tabs>
    </div>
  ) : (
    <div />
  );
}
